/*
 * Copyright (C) 2019 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, Input, OnInit } from '@angular/core';
import { getSpectrumTraits } from '@app/app/page-modules/personality-indicator/pi-questions/pi-report/report-constants';
import { ChartEditorContent, PIReport, PIScore } from '../../../../shared/models/pi/pi.model';
import { PIDataService, PI_DATA_SERVICE } from '../../../../shared/services/pi/pi-data.service';

@Component({
  selector: 'ptl-pi-spectrum-chart',
  templateUrl: './pi-spectrum-chart.component.html',
  styleUrls: ['./pi-spectrum-chart.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PersonalIndicatorSpectrumChartComponent implements OnInit {
  @Input() content: ChartEditorContent;

  @Input() showStaticData: boolean;

  @Input() reports: PIReport[];

  @Input() isPIReport: boolean;

  piReport: PIReport[];
  chartData: PIScore[];

  readonly traitMapping = getSpectrumTraits();

  constructor(
    @Inject(PI_DATA_SERVICE) private piDataService: PIDataService,
    private cd: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    if (!this.showStaticData && this.content) {
      if (this.isPIReport && this.reports) {
        this.setReportData(this.reports);
        return;
      }
      this.piDataService.getPIReports(this.content.piCardId).subscribe(({ isSuccess, value }) => {
        if (isSuccess && value.reports.length) {
          this.setReportData(value.reports);
        }
      });
    }
  }

  private setReportData(reports: PIReport[]) {
    this.piReport = reports;
    this.chartData = [...this.piReport[0].traitScoreReport.traitScores];
    this.chartData.sort(this.compareFunction);
    this.cd.detectChanges();
  }

  private compareFunction = (a: PIScore, b: PIScore): number => {
    if (!this.traitMapping[a.name] || this.traitMapping[a.name]?.imageUrl < this.traitMapping[b.name]?.imageUrl) {
      return -1;
    } else if (!this.traitMapping[b.name] || this.traitMapping[a.name]?.imageUrl > this.traitMapping[b.name]?.imageUrl) {
      return 1;
    } else {
      return 0;
    }
  };
}
